/** Strip accents and normalize to uppercase for fuzzy letter matching. */
export function normalize(s: string): string {
  return s
    .toUpperCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}
